module.exports = __webpack_public_path__ + "static/media/wth-shirts.d8ba753f.png";